import { render, staticRenderFns } from "./FormRegistered.vue?vue&type=template&id=0846a6e0&"
import script from "./FormRegistered.vue?vue&type=script&lang=js&"
export * from "./FormRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports